import { render, staticRenderFns } from "./payhint.vue?vue&type=template&id=2c954110&scoped=true&"
import script from "./payhint.vue?vue&type=script&lang=js&"
export * from "./payhint.vue?vue&type=script&lang=js&"
import style0 from "./payhint.vue?vue&type=style&index=0&id=2c954110&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c954110",
  null
  
)

export default component.exports